import { CxEvent } from '@spartacus/core';

export class GtmGgCartPageEvent extends CxEvent {
  event?: string;
  ecommerce?: {
    checkout?: {
      actionField?: {
        step?: number;
      };
      products?: {
        name?: string;
        price?: string;
        category?: string;
        id?: string;
        variant?: string;
        brand?: string;
        quantity?: number;
      }[];
    };
  };
}
